import src from "IMAGE";
export default { src, width: 288, height: 69, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AH5+flVSUlI3X19fRICAgFtxcXFQZ2dnQ2tra0hZWVk1AGNjY0dWVlY6XV1dQWpqakdlZWVGhYWFUJSUlFiLi4tIIXUY998kBJcAAAAASUVORK5CYII="};
